import { fromJS } from 'immutable';
export var SET_TERMINALS_MAPE_DATA = 'mape/SET_TERMINALS_MAPE_DATA';
export var SET_TERMINALS_MAPE_BY_WEEK = 'mape/SET_TERMINALS_MAPE_BY_WEEK';
export var SET_TERMINAL_ID = 'mape/SET_TERMINAL_ID';
export var SET_GATE_TO_AND_FRO_ID = 'mape/SET_GATE_TO_AND_FRO_ID';
export var SET_GATE_TO_AND_FRO_LIST = 'mape/SET_GATE_TO_AND_FRO_LIST';
export var SET_GATE_TO_AND_FRO_MAPE_DATA = 'mape/SET_GATE_TO_AND_FRO_MAPE_DATA';
export var SET_GATE_TO_AND_FRO_MAPE_TOTAL = 'mape/SET_GATE_TO_AND_FRO_MAPE_TOTAL';
export var SET_GATE_TO_AND_FRO_MAPE_BY_WEEK = 'mape/SET_GATE_TO_AND_FRO_MAPE_BY_WEEK';
export var SET_VEHICLE_VOLUMES = 'mape/SET_VEHICLE_VOLUMES';
export var SET_DELIVERY_ID = 'mape/SET_DELIVERY_ID';
export var SET_DELIVERY_MAPE_BY_TERMINAL_DELIVER_TYPE = 'mape/SET_DELIVERY_MAPE_BY_TERMINAL_DELIVER_TYPE';
export var SET_DELIVERY_MAPE_BY_WEEK = 'mape/SET_DELIVERY_MAPE_BY_WEEK';
export var SET_ROAD_SECTION_LIST = 'mape/SET_ROAD_SECTION_LIST';
export var SET_ROAD_SECTION_BY_WEEK = 'mape/SET_ROAD_SECTION_BY_WEEK';
export var SET_ROAD_SECTION_MAPE_DATA = 'mape/SET_ROAD_SECTION_MAPE_DATA';
export var SET_ROAD_SECTION_ID = 'mape/SET_ROAD_SECTION_ID';
export var SET_DATE_RANGE = 'mape/SET_DATE_RANGE';
export var SET_DATE_RANGE_CHANGE_SWITCH = 'mape/SET_DATE_RANGE_CHANGE_SWITCH';
export var RESET = 'mape/RESET';
export var setTerminalsMapeData = function setTerminalsMapeData(data) {
  return {
    type: SET_TERMINALS_MAPE_DATA,
    data: data
  };
};
export var setTerminalsMapeByWeek = function setTerminalsMapeByWeek(data) {
  return {
    type: SET_TERMINALS_MAPE_BY_WEEK,
    data: data
  };
};
export var setTerminalId = function setTerminalId(data) {
  return {
    type: SET_TERMINAL_ID,
    data: data
  };
};
export var setGateToAndFroId = function setGateToAndFroId(data) {
  return {
    type: SET_GATE_TO_AND_FRO_ID,
    data: data
  };
};
export var setGateToAndFroMapeData = function setGateToAndFroMapeData(data) {
  return {
    type: SET_GATE_TO_AND_FRO_MAPE_DATA,
    data: data
  };
};
export var setGateToAndFroMapeTotal = function setGateToAndFroMapeTotal(data) {
  return {
    type: SET_GATE_TO_AND_FRO_MAPE_TOTAL,
    data: data
  };
};
export var setGateToAndFroList = function setGateToAndFroList(data) {
  return {
    type: SET_GATE_TO_AND_FRO_LIST,
    data: data
  };
};
export var setGateToAndFroMapeByWeek = function setGateToAndFroMapeByWeek(data) {
  return {
    type: SET_GATE_TO_AND_FRO_MAPE_BY_WEEK,
    data: data
  };
};
export var setVehicleVolumes = function setVehicleVolumes(data) {
  return {
    type: SET_VEHICLE_VOLUMES,
    data: data
  };
};
export var setDeliveryId = function setDeliveryId(data) {
  return {
    type: SET_DELIVERY_ID,
    data: data
  };
};
export var setDeliveryMapeByTerminalDeliverType = function setDeliveryMapeByTerminalDeliverType(data) {
  return {
    type: SET_DELIVERY_MAPE_BY_TERMINAL_DELIVER_TYPE,
    data: data
  };
};
export var setDeliveryMapeByWeek = function setDeliveryMapeByWeek(data) {
  return {
    type: SET_DELIVERY_MAPE_BY_WEEK,
    data: data
  };
};
export var setRoadSectionList = function setRoadSectionList(data) {
  return {
    type: SET_ROAD_SECTION_LIST,
    data: data
  };
};
export var setRoadSectionByWeek = function setRoadSectionByWeek(data) {
  return {
    type: SET_ROAD_SECTION_BY_WEEK,
    data: data
  };
};
export var setRoadSectionMapeData = function setRoadSectionMapeData(data) {
  return {
    type: SET_ROAD_SECTION_MAPE_DATA,
    data: data
  };
};
export var setRoadSectionId = function setRoadSectionId(data) {
  return {
    type: SET_ROAD_SECTION_ID,
    data: data
  };
};
export var setDateRange = function setDateRange(data) {
  return {
    type: SET_DATE_RANGE,
    data: data
  };
};
export var setDateRangeChangeSwitch = function setDateRangeChangeSwitch(data) {
  return {
    type: SET_DATE_RANGE_CHANGE_SWITCH,
    data: data
  };
};
export var reset = function reset() {
  return {
    type: RESET
  };
};
var initialState = fromJS({
  terminalsMapeData: [],
  terminalsMapeByWeek: [],
  terminalId: '',
  gateToAndFroId: '',
  gateToAndFroList: [],
  gateToAndFroMapeData: [],
  gateToAndFroMapeTotal: -1,
  gateToAndFroMapeByWeek: [],
  vehicleVolumes: [],
  deliveryId: '',
  // deliveryList: [],
  deliveryMapeByTerminalDeliverType: [],
  deliveryMapeByWeek: [],
  roadSectionList: [],
  roadSectionByWeek: [],
  roadSectionMapeData: [],
  roadSectionId: '',
  dateRange: {
    to: '',
    from: ''
  },
  dateRangeChangeSwitch: true
});
export default function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SET_TERMINALS_MAPE_DATA:
      return state.set('terminalsMapeData', fromJS(action.data));

    case SET_TERMINALS_MAPE_BY_WEEK:
      return state.set('terminalsMapeByWeek', fromJS(action.data));

    case SET_TERMINAL_ID:
      return state.set('terminalId', fromJS(action.data));

    case SET_GATE_TO_AND_FRO_ID:
      return state.set('gateToAndFroId', fromJS(action.data));

    case SET_GATE_TO_AND_FRO_LIST:
      return state.set('gateToAndFroList', fromJS(action.data));

    case SET_GATE_TO_AND_FRO_MAPE_DATA:
      return state.set('gateToAndFroMapeData', fromJS(action.data));

    case SET_GATE_TO_AND_FRO_MAPE_TOTAL:
      return state.set('gateToAndFroMapeTotal', fromJS(action.data));

    case SET_GATE_TO_AND_FRO_MAPE_BY_WEEK:
      return state.set('gateToAndFroMapeByWeek', fromJS(action.data));

    case SET_VEHICLE_VOLUMES:
      return state.set('vehicleVolumes', fromJS(action.data));

    case SET_DELIVERY_ID:
      return state.set('deliveryId', fromJS(action.data));

    case SET_DELIVERY_MAPE_BY_TERMINAL_DELIVER_TYPE:
      return state.set('deliveryMapeByTerminalDeliverType', fromJS(action.data));

    case SET_DELIVERY_MAPE_BY_WEEK:
      return state.set('deliveryMapeByWeek', fromJS(action.data));

    case SET_ROAD_SECTION_LIST:
      return state.set('roadSectionList', fromJS(action.data));

    case SET_ROAD_SECTION_BY_WEEK:
      return state.set('roadSectionByWeek', fromJS(action.data));

    case SET_ROAD_SECTION_MAPE_DATA:
      return state.set('roadSectionMapeData', fromJS(action.data));

    case SET_ROAD_SECTION_ID:
      return state.set('roadSectionId', fromJS(action.data));

    case SET_DATE_RANGE:
      return state.set('dateRange', fromJS(action.data));

    case SET_DATE_RANGE_CHANGE_SWITCH:
      return state.set('dateRangeChangeSwitch', fromJS(action.data));

    case RESET:
      return initialState;

    default:
      return state;
  }
}